"use strict";

AddGroupToLinkDirective.$inject = ['CompanyGroupService', '$stateParams'];
function AddGroupToLinkDirective(CompanyGroupService, $stateParams) {
  return {
    restrict: 'EA',
    replace: true,
    scope:  {
      "roleLink": "="
    },
    templateUrl:'partials/company/user-roles/link-permission.html',
    link: function(scope, element) {
      if (!scope.roleLink.groups) {
        scope.roleLink.groups = [];
      }
      scope.queryGroups = function(filter) {
        CompanyGroupService.query({companyId: $stateParams.companyId, q: filter, limit: 6, type: null}).$promise.then(function(groups) {
          scope.searchResult = groups.filter(function(g) {
            return !scope.roleLink.groups.some(function(g1) {
              return g1.id === g.id;
            });
          });
        });
      };

      scope.add = function(group, index) {
        scope.roleLink.groups.push({id: group.id, name: group.name});
        scope.searchResult.splice(index, 1);
        angular.element(element).find('input').val('');
      };

      scope.remove = function(index) {
        scope.roleLink.groups.splice(index, 1);
      };
    }
  };
}

angular.module('dokiv')
  .directive('addGroupToLink', AddGroupToLinkDirective);


//////////////////
// WEBPACK FOOTER
// ./scripts/company/user-roles/AddGroupToLinkDirective.js
// module id = 424
// module chunks = 0